module.exports = __webpack_public_path__ + "img/outline-ci-black.fa5c5b8.svg";